import FastImage from 'react-native-fast-image';
import {ScrollView} from 'react-native-gesture-handler';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const Container = styled.View`
  flex: 1;
`;

export const Content = styled.View`
  flex: 1;
`;

export const ScrollContent = styled(ScrollView)`
  flex: 1;
  padding: 0 24px;
`;

export const PlayerWrapper = styled.View`
  width: 100%;
  border-radius: ${RFValue(14)}px;
  overflow: hidden;
  background-color: #000;
`;

export const VideoInfoContainer = styled.View`
  margin-top: ${RFValue(16)}px;
  margin-bottom: ${RFValue(12)}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LessonTagContainer = styled.View`
  align-self: flex-start;
  padding: ${RFValue(4)}px ${RFValue(10)}px;
  border-radius: 14px;
  background-color: ${({theme}) => theme.colors.primary_light};
`;

export const LessonTag = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;

  text-transform: uppercase;
`;

export const VideoTitle = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  margin-top: ${RFValue(10)}px;
`;

export const VideoDescription = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  margin-top: ${RFValue(4)}px;
  
`;

export const SectionTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};


`;

export const LessonList = styled.View`
  padding-bottom: ${RFValue(24)}px;
`;

interface ILessonItem {
  active?: boolean;
}

export const LessonItem = styled.TouchableOpacity<ILessonItem>`
  flex-direction: row;
  align-items: center;
  padding: ${RFValue(8)}px;
  margin-bottom: ${RFValue(8)}px;
  border-radius: ${RFValue(12)}px;
  background-color: ${({theme, active}) =>
    active ? theme.colors.primary_light : 'transparent'};
`;

export const LessonThumbWrapper = styled.View`
  position: relative;
  width: ${RFValue(104)}px;
  height: ${RFValue(60)}px;
  border-radius: ${RFValue(10)}px;
  overflow: hidden;
  background-color: #000;
`;

//@ts-ignore
export const LessonThumb = styled(FastImage)`
  width: 100%;
  height: 100%;
`;

export const ThumbOverlay = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.28);
`;

interface IPlayButton {
  active?: boolean;
}

export const PlayButton = styled.View<IPlayButton>`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  border-radius: ${RFValue(14)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({theme, active}) =>
    active ? theme.colors.shape : theme.colors.primary};
`;

export const PlayIcon = styled(MaterialCommunityIcons)<IPlayButton>`
  font-size: ${RFValue(14)}px;
  color: ${({theme, active}) =>
    active ? theme.colors.primary : theme.colors.shape};
`;

export const DurationBadge = styled.View`
  position: absolute;
  right: ${RFValue(4)}px;
  bottom: ${RFValue(4)}px;
  background-color: rgba(0, 0, 0, 0.75);
  padding: ${RFValue(2)}px ${RFValue(5)}px;
  border-radius: ${RFValue(4)}px;
`;

export const DurationText = styled.Text`
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: #fff;
`;

export const LessonInfo = styled.View`
  flex: 1;
  margin-left: ${RFValue(12)}px;
`;

export const LessonNumber = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.text_2};
  text-transform: uppercase;
`;

interface ILessonItemTitle {
  active?: boolean;
}

export const LessonItemTitle = styled.Text<ILessonItemTitle>`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme, active}) =>
    active ? theme.colors.primary : theme.colors.title};
  
`;
